(ns frontend.test.state-indicator
  (:require [frontend.routing :as routing]
            [frontend.bootstrap.components :as rbs]))

(defmethod routing/render-view :test/state-indicator [{:keys [route-params]}]
  (let []
    [:div.container.bg-white.scroll.pb-5
     [:h3.title-h3.my-3 "State indicator"]

     [:div.state-indicator
      [:div.state-indicator__item.state-indicator__item--completed [:span "Edit Content"]]
      [:div.state-indicator__item [:span "Wait for Zadmin's approval"]]
      [:div.state-indicator__item [:span "Published"]]]
     ]))
